// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HbxXf","inner":"Footer_inner__3IXJM","nextIcon":"Footer_nextIcon__1VOi7","innerLeft":"Footer_innerLeft__3m_21"};